import { render, staticRenderFns } from "./copy-text-field.vue?vue&type=template&id=21e38192&scoped=true"
import script from "./copy-text-field.vue?vue&type=script&lang=js"
export * from "./copy-text-field.vue?vue&type=script&lang=js"
import style0 from "./copy-text-field.vue?vue&type=style&index=0&id=21e38192&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e38192",
  null
  
)

export default component.exports